/* eslint-disable max-len */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';

export default class BaseTransformNode extends BaseNode {
    functionName: string;

    inputDataType: TibboDataType;

    outputDataType: TibboDataType;

    constructor() {
        super();
        this.linkedFeature = 'general';
    }

    setPorts() {
        this.inputs = [
            {
                name: 'number',
                portId: 'call',
                params: [
                    {
                        name: 'input',
                        dataType: this.inputDataType,
                        default: '0',
                    },
                ],
            },
        ];

        this.outputs = [
            {
                name: 'Result',
                portId: 'answer',
                params: [
                    {
                        name: `${this.functionName}_answer`,
                        dataType: this.outputDataType,
                    },
                ],
            },
        ];
    }

    getFunctionBody(): string {
        return '';
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const incomingLinks = project.getNodeLinks(this, 'call');
        const outgoing = project.getNodeLinks(this, 'answer');

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            id: `declare_${this.functionName}`,
            blockType: BlockType.CODE,
            template: `
declare function ${this.functionName}(input as ${this.inputDataType}) as ${this.outputDataType}
`,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            id: `${this.functionName}`,
            blockType: BlockType.CODE,
            template: `
function ${this.functionName}(input as ${this.inputDataType}) as ${this.outputDataType}
    ${this.getFunctionBody()}
end function
`,
        });

        for (let i = 0; i < incomingLinks.length; i += 1) {
            const link = incomingLinks[i];
            if (outgoing.length > 0) {
                blocks.push({
                    location: link.getSourceId(),
                    blockType: BlockType.CODE,
                    template: `
    dim ${this.functionName}_answer as ${this.outputDataType} = ${this.functionName}(${project.getNodeParameter(link, 'input')})
    '****${outgoing[0].getSourceId()}****'`,
                });
            }
        }
        return blocks;
    }
}
